export const isRequired = (value) => {
  if (!value && value !== 0) {
    return 'commonErrors.required';
  }
};

export const isRecaptchaRequired = (isReCaptureValid) => {
  if (!isReCaptureValid) {
    return 'commonErrors.required';
  }
};

export const isEmail = (value) => {
  if (value && !/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(value)) {
    return 'formValidation.invalidEmail';
  }
};

export const areEmailsMatch = (value, { email }) => {
  if (value !== email) {
    return 'formValidation.emailMismatched';
  }
};

export const isValidPhone = (value) => {
  if (value && !/^\+?\d+$/.test(value)) {
    return 'formValidation.wrongPhoneFormat';
  }
};

export const isValidPassword = (value) => {
  const errors = [];

  const hasNoWhiteSpaces = /^\S*$/.test(value);
  const hasUpperCase = /[A-Z]/.test(value);
  const hasDigit = /\d/.test(value);

  if (!hasUpperCase) errors.push('formValidation.withoutUpperMessage');
  if (!hasDigit) errors.push('formValidation.withoutDigitMessage');
  if (!hasNoWhiteSpaces) errors.push('formValidation.withoutWhiteSpaces');
  if (value.length < 8) errors.push('formValidation.passLength');

  if (!errors.length) return;

  return errors;
};

export const arePasswordsMatch = (value, { password }) => {
  if (value !== password) {
    return 'formValidation.passMismatched';
  }
};
